import React from "react";
import { Button } from "@mui/material";

export default function ArrayToCSV({ data, csvFileName }) {
  const flattenData = (obj) => {
    const result = {};
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        const flattened = flattenData(obj[key]);
        for (const nestedKey in flattened) {
          result[`${key}_${nestedKey}`] = flattened[nestedKey];
        }
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  };

  const convertToCsv = (data) => {
    const flattenedData = data.map(flattenData);

    const headers = Array.from(
      new Set(flattenedData.flatMap((item) => Object.keys(item)))
    );
    const csvRows = flattenedData.map((item) =>
      headers
        .map((header) => {
          const value = item[header];
          return typeof value === "string"
            ? `"${value.replace(/"/g, '""')}"`
            : value;
        })
        .join(",")
    );

    const csv = "\uFEFF" + headers.join(",") + "\r\n" + csvRows.join("\r\n");
    return csv;
  };

  const downloadCsv = () => {
    const csvData = convertToCsv(data);

    // Generate a dynamic filename with the current date
    const currentDate = new Date().toISOString().slice(0, 10);

    const filename = `${csvFileName}_${currentDate}.csv`;

    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Download is not supported in this browser.");
    }
  };

  return (
    <Button color="error" onClick={downloadCsv} variant="contained">
      Download CSV
    </Button>
  );
}
